import axios from 'axios'; 


export const getMedia = (projectId) => {
    return axios
        .get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/latestmedia`);
};
